module.exports = __webpack_public_path__ + "img/img9.2d5b905d.svg";